import {connect} from 'react-redux'
import {isNil} from "lodash"
import QuotingFilterSidebar from './quotingFilterSidebar'
import {quoteSelectorUpdateFilters} from 'actions/quoting'
import {getHomeContacts, getOrderTypes} from 'selectors/data'
import {getUser} from 'selectors/auth'
import {getQuotingSelector} from 'selectors/quotes'
import {getInvoiceFinancialYearStart} from 'selectors/settings'
import {getDeliveriesQuoteSelector} from "selectors/deliveries"
import {getDateFilters} from 'helpers/dateRange'

const mapStateToProps = (state, ownProps) => {
  const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
  const filters = !isNil(ownProps.onUpdateFiltersFromDeliveries)
      ? getDeliveriesQuoteSelector(state)
      : getQuotingSelector(state)
  const {
    allRevisions,
    statusTypes,
    companies,
    userTypes,
    contacts,
    dateTypes,
    includeFullyScheduled,
    timeKey,
    orderTypeId,
    includeFullyDelivered,
  } = filters
  const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)

  return {
    user: getUser(state),
    homeContacts: getHomeContacts(state),
    orderTypes: getOrderTypes(state),
    allRevisions,
    statusTypes,
    companies,
    userTypes,
    contacts,
    dateTypes,
    includeFullyScheduled,
    timeKey,
    targetStart,
    targetEnd,
    orderTypeId,
    includeFullyDelivered,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateFilters: (filters) => dispatch(quoteSelectorUpdateFilters(filters)),
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuotingFilterSidebar)
